import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
    selector: 'input[type=file]',
    host: {
        '(change)': 'onChange($event.target.files)',
        '(blur)': 'onTouched()',
    },
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: FileValueAccessor, multi: true },
    ],
    standalone: false
})
export class FileValueAccessor implements ControlValueAccessor {
  value: FileList | null = null;
 
  onTouched = () => { };
 
  writeValue(value: any): void {
    if (value) {
      this.value = value;
    } else {
      this.value = null;
    }
  }
 
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
 
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
 
  onChange(eventFiles: FileList): void {
    this.value = eventFiles;
    this.onChange(this.value);  
  }
}
